import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import urlJoin from 'url-join';
import defaultStyles from '../modal/AppModal.module.scss';
import AppModal from '../modal/AppModal';

const heading = 'Warning';
const message = 'Your session has expired due to inactivity. '
    + 'For your security the current form has been deleted from the browser. '
    + 'Reload this page to log in to the system again.';
const submit = 'Reload';

const AdfsLogout = (props) => {
    const buttonClick = useCallback(() => {
        const currentPath = window.location.href.replace(window.location.origin, '');
        if (currentPath === props.refreshPath) {
            window.location.reload();
        } else {
            // don't want the user to go back to the loggout page
            window.location.replace(props.refreshPath);
        }
    }, [props.refreshPath]);

    useEffect(() => {
        if (props.setRefreshPathWhenShown) {
            window.history.replaceState({}, '', props.refreshPath);
        }
    }, [props.refreshPath, props.setRefreshPathWhenShown]);

    return (
        <AppModal isOpen heading={ heading } message={ message } submit={ submit } onButtonClick={ buttonClick } />
    );
};

AdfsLogout.propTypes = {
    styles: PropTypes.shape({
        modal: PropTypes.string,
        overlay: PropTypes.string,
        heading: PropTypes.string,
        message: PropTypes.string,
        button: PropTypes.string,
        content: PropTypes.string
    }),
    refreshPath: PropTypes.string,
    setRefreshPathWhenShown: PropTypes.bool
};

const virtualDirectory = (window.APP_ENV_CONFIG && window.APP_ENV_CONFIG.APP_VIRTUAL_DIR) || '';
const appRootPath = urlJoin('/', virtualDirectory);

AdfsLogout.defaultProps = {
    styles: defaultStyles,
    refreshPath: appRootPath,
    setRefreshPathWhenShown: true
};

export default AdfsLogout;
